<template>
    <div class="msg-detail">
		<Loading v-if="!loading"/>
        <div class="title">北门中文网通知</div>
        <div class="date">{{msgContent.updated_at}}</div>
        <div class="main" v-if="loading">{{msgContent.content}}</div>
    </div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import Loading from '@/components/Loading'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
	name:'MsgDetail',
	data(){
		return{
			msgContent:'',             //储存消息详情内内容
			loading:false              //加载页面显示隐藏控制
		}
	},
	created(){
		//获取消息详情
		Axios.get('/user/message/detail',{params:{message_id:this.$route.query.id}})
		.then(
			response=>{
				if(response.data.code==200&&response.data.status=="success"){
					this.loading=true
					this.msgContent=response.data.data
				}
			}
		).catch(
			error=>{
				this.$swal({
					text:'网络错误 请稍后重试',
					showConfirmButton:false,
					width:'6rem',
					padding:'0.5rem',
					timer:1200,
					imageWidth:50,
					imageHeight:50,
					imageUrl:notifyIcon,
					timerProgressBar: true
				})
			}
		)
		//消息已读状态变更
		Axios.get('/user/message/change',{params:{message_id:this.$route.query.id}})
	},
	components:{
		Loading
	}
}
</script>

<style lang="scss" scoped>
    .msg-detail{
        padding:70px 44px;
		padding-top:148px;
        .title{
            font-size:32px;
            color:#222;
            font-weight:bold;
            margin-bottom:18px;
        }
        .date{
            font-size:22px;
            color:#999;
            margin-bottom:60px;
        }
        .main{
            font-size:22px;
            color:#222;
            line-height:40px;
        }
    }
</style>